// Action
import { updateStaticPageAction } from '../../../actions/siteadmin/updateStaticPage';
import showToaster from '../../../helpers/toasterMessages/showToaster';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {

  const isRestrict = await dispatch(demoRestriction({}));

  if (isRestrict) return;

  const dynamicStaticPage = values?.dynamicStaticPage || [];

  let hasError = false;

  dynamicStaticPage.forEach((item) => {

    if (!item?.language) {
      showToaster({
        messageId: 'chooseLanguage',
        toasterType: 'error'
      });
      hasError = true;
    }

    else if (
      item?.metaTitle == null ||
      item?.metaTitle?.trim() === ''
    ) {
      showToaster({
        messageId: 'addMetaTitle',
        toasterType: 'error'
      });
      hasError = true;
    }

    else if (
      item?.metaDescription == null ||
      item?.metaDescription?.trim() === ''
    ) {
      showToaster({
        messageId: 'addMetaDescription',
        toasterType: 'error'
      });
      hasError = true;
    }

    else if (
      item?.content == null ||
      item?.content === '<p><br></p>' ||
      item?.content === '<p> </p>'
    ) {
      showToaster({
        messageId: 'addContent',
        toasterType: 'error'
      });
      hasError = true;
    }

  });

  if (hasError) return;

  await dispatch(updateStaticPageAction(values));
}

export default submit;